module.exports = __webpack_public_path__ + "img/04_mzste8_c_scale,w_200.32122307.jpg";